module.exports = __webpack_public_path__ + "media/src/images/logos/partners/steam-cec934e8652442c13afab2dce66131e2.png";